import { render, staticRenderFns } from "./VaimoFocusTrapWrapper.vue?vue&type=template&id=266586b1&"
import script from "./VaimoFocusTrapWrapper.vue?vue&type=script&lang=js&"
export * from "./VaimoFocusTrapWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports